module.exports = "input[type=\"button\"] {\n  display: block;\n  min-height: 25px;\n  min-width: 100px;\n  width: 100%;\n  text-transform: uppercase;\n  background-color: steelblue;\n  color: white;\n  border-radius: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/asset-tags/asset-tags.component.scss
// module id = 1158
// module chunks = 1